import { applyAppFontSizePt, resolveStoredAppFontSizePt } from 'src/stores/userInterfaceSettings/appFontSize';
import {
	APP_FONT_SIZE_PERCENT_KEY,
	APP_FONT_SIZE_PT_KEY,
	SOFT_SHADOWS_KEY,
} from 'src/stores/userInterfaceSettings/localStorageKeys';

export function bootAppearance(): void {
	const manageCssClass = (className: string, shouldAdd: boolean) => {
		if (shouldAdd) {
			document.body.classList.add(className);
		} else {
			document.body.classList.remove(className);
		}
	};

	const getLocalStorageBoolean = (key: string, defaultValue = false): boolean => {
		const value = localStorage.getItem(key);
		if (value !== null) {
			return /true/i.test(value);
		}
		return defaultValue;
	};

	const shouldUseSoftShadows = getLocalStorageBoolean(SOFT_SHADOWS_KEY, false);
	manageCssClass('soft-shadows', shouldUseSoftShadows);
	applyAppFontSizePt(
		resolveStoredAppFontSizePt(
			localStorage.getItem(APP_FONT_SIZE_PT_KEY),
			localStorage.getItem(APP_FONT_SIZE_PERCENT_KEY)
		)
	);
}
